import api from "./api"

export const getStats = async (organizationId) => {
  try {
    if (!organizationId) {
      throw new Error("Organization ID is required")
    }

    // Use the correct endpoint structure with organizationId in the path
    const response = await api.get(`/organizations/${organizationId}/stats`)
    return response.data
  } catch (error) {
    console.error("Error fetching stats:", error)
    throw error
  }
}

export const getActivityFeed = async (limit = 5) => {
  try {
    const response = await api.get("/analytics/activity", {
      params: { limit },
    })
    return response.data
  } catch (error) {
    console.error("Error fetching activity feed:", error)
    throw error
  }
}

export const getTrendData = async (period = "month") => {
  try {
    const response = await api.get("/analytics/trends", {
      params: { period },
    })
    return response.data
  } catch (error) {
    console.error("Error fetching trend data:", error)
    throw error
  }
}

export const getSubscriptionDistribution = async () => {
  try {
    const response = await api.get("/analytics/subscription-distribution")
    return response.data
  } catch (error) {
    console.error("Error fetching subscription distribution:", error)
    throw error
  }
}

